import { render, staticRenderFns } from "./DocumentGroupViewModal.vue?vue&type=template&id=77890190&scoped=true&"
import script from "./DocumentGroupViewModal.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupViewModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupViewModal.vue?vue&type=style&index=0&id=77890190&prod&scoped=true&lang=css&"
import style1 from "./DocumentGroupViewModal.vue?vue&type=style&index=1&id=77890190&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77890190",
  null
  
)

export default component.exports